export const bg1Data = {
    src: "/otplanding/rectangle@2x.png",
};

export const x41Data = {
    bgProps: bg1Data,
};

export const bg2Data = {
    src: "/otplanding/rectangle@2x.png",
    className: "bg-1",
};

export const x61Data = {
    bgProps: bg2Data,
};

export const bg3Data = {
    src: "/otplanding/rectangle-9@2x.png",
    className: "bg-2",
};

export const x11Data = {
    bgProps: bg3Data,
};

export const bg4Data = {
    src: "/otplanding/rectangle-10@2x.png",
    className: "bg-3",
};

export const icon1Data = {
    bgProps: bg4Data,
};

export const x21Data = {
    iconProps: icon1Data,
};

export const bg5Data = {
    src: "/otplanding/rectangle-3@2x.png",
    className: "bg-2",
};

export const icon2Data = {
    className: "icon-3",
    bgProps: bg5Data,
};

export const x31Data = {
    iconProps: icon2Data,
};

export const protokolEkosistem2Data = {
    className: "protokol-ekosistem-3",
};

export const analitikaPotrazivanjaIDugovanja1Data = {
    anastasiaDanUxB: "analitika  potraživanja i dugovanja",
};

export const starter1Data = {
    analitikaPotrazivanjaIDugovanjaProps: analitikaPotrazivanjaIDugovanja1Data,
};

export const analitikaPotrazivanjaIDugovanja2Data = {
    anastasiaDanUxB: "evidencija i praćenje troškova",
};

export const analitikaPotrazivanjaIDugovanja3Data = {
    anastasiaDanUxB: "analitika  potraživanja i dugovanja",
};

export const premium1Data = {
    analitikaPotrazivanjaIDugovanja1Props: analitikaPotrazivanjaIDugovanja2Data,
    analitikaPotrazivanjaIDugovanja2Props: analitikaPotrazivanjaIDugovanja3Data,
};

export const supportInfo1Data = {
    excepteurSintOccae: "/otplanding/excepteur-sint-occae-1@2x.png",
};

export const x121Data = {
    duisAuteIrureDolo: "brzo i jednostavno do webshopa",
    iconCheck_Mark: "/otplanding/path-3@2x.png",
};

export const x122Data = {
    duisAuteIrureDolo: "automatizacija poručivanja i dostave",
    iconCheck_Mark: "/otplanding/path-5@2x.png",
    className: "features-ecommerce-item",
};

export const x3VarijantaData = {
    footerINewsletter: "/otplanding/footer-i-newsletter.png",
    resources: "resursi",
    nostrudExercitation1: "How to?",
    visualMockups: "Česta pitanja",
    nostrudExercitation2: "public restAPI",
    company: "informacije",
    consecteturAdipisci1: "Opšti uslovi korišćenja",
    laboreEtDolore: "politika o privatnosti",
    consecteturAdipisci2: "politika o kolačićima",
    strateskiPartneri: "strateški partneri",
    activateLogo_Mono_Darkbg1: "/otplanding/activate-logo-mono-darkbg-1@2x.png",
    vector2: "/otplanding/vector-1@2x.png",
    x13: "/otplanding/13.png",
    headerNavBar: "/otplanding/header-nav-bar.png",
    soloLogoProtokolBeli8: "/otplanding/solo-logo-protokol-beli-8@2x.png",
    upravljaj: "upravljaj.",
    spanText1: "integriši",
    spanText2: ".",
    spanText3: "automatizuj",
    spanText4: ".",
    credoSentence: "/otplanding/credo-sentence@2x.png",
    x12: "/otplanding/12.png",
    x15: "/otplanding/12.png",
    x14: "/otplanding/12.png",
    moreSpeedLessSpe1: "brže, jednostavnije, efikasnije",
    spanText5: "Poslovođa ",
    spanText6: "uvek ažurne finansije",
    loremIpsumDolorSi1: "jednostavan način za rukovođenjem vašeg poslovanja,<br />upravljajte finansijama, stanjem robe, uslugama, potraživanjima i dugovanjima.",
    ametConsecteturAdi: "analitika  kupaca, dobavljača, prometa, zaliha robe...",
    path2: "/otplanding/path@2x.png",
    excepteurSintOccae1: "pregled statusa svih transakcija u svakom trenutku",
    path3: "/otplanding/path@2x.png",
    duisAuteIrureDolo: "kreiraj fakture u par klikova",
    arhivator: "/otplanding/arhivator.png",
    moreSpeedLessSpe2: "brže, jednostavnije efikasnije",
    spanText7: "eCommerce ",
    spanText8: "po vašoj meri",
    loremIpsumDolorSi2: "počnite da zarađujete više jednim klikom putem<br />miniShopa webStore ili B2B portala uz<br />automatska ažuriranja stanja i prometa.",
    excepteurSintOccae2: "sinhronizacija podataka u okviru platforme",
    path4: "/otplanding/path-4@2x.png",
    x4Props: x41Data,
    x6Props: x61Data,
    x1Props: x11Data,
    x2Props: x21Data,
    x3Props: x31Data,
    protokolEkosistemProps: protokolEkosistem2Data,
    starterProps: starter1Data,
    premiumProps: premium1Data,
    supportInfoProps: supportInfo1Data,
    x121Props: x121Data,
    x122Props: x122Data,
};

export const frame522Data = {
    className: "frame-52-1",
};

export const moto22Data = {
    className: "moto-2-1",
};

export const bg6Data = {
    src: "/otplanding/rectangle@2x.png",
};

export const x42Data = {
    className: "x4-2",
    bgProps: bg6Data,
};

export const bg7Data = {
    src: "/otplanding/rectangle@2x.png",
    className: "bg-6",
};

export const x62Data = {
    className: "x6-2",
    bgProps: bg7Data,
};

export const bg8Data = {
    src: "/otplanding/rectangle-10@2x.png",
    className: "bg-2",
};

export const x13Data = {
    className: "x1-2",
    bgProps: bg8Data,
};

export const bg9Data = {
    src: "/otplanding/rectangle-10@2x.png",
    className: "bg-8",
};

export const icon3Data = {
    bgProps: bg9Data,
};

export const x22Data = {
    iconProps: icon3Data,
};

export const bg10Data = {
    src: "/otplanding/rectangle-10@2x.png",
    className: "bg-2",
};

export const icon4Data = {
    className: "icon-5",
    bgProps: bg10Data,
};

export const x32Data = {
    className: "x3-3",
    iconProps: icon4Data,
};

export const protokolEkosistem3Data = {
    className: "protokol-ekosistem-4",
};

export const protokolEkosistem4Data = {
    className: "protokol-ekosistem-5",
};

export const svaPoslovnaResenjaNaJednomMestu2Data = {
    className: "sva-poslovna-resenja-na-jednom-mestu-2",
};

export const analitikaPotrazivanjaIDugovanja4Data = {
    anastasiaDanUxB: "analitika  potraživanja i dugovanja",
};

export const starter2Data = {
    className: "starter-2",
    analitikaPotrazivanjaIDugovanjaProps: analitikaPotrazivanjaIDugovanja4Data,
};

export const analitikaPotrazivanjaIDugovanja5Data = {
    anastasiaDanUxB: "evidencija i praćenje troškova",
};

export const analitikaPotrazivanjaIDugovanja6Data = {
    anastasiaDanUxB: "analitika  potraživanja i dugovanja",
};

export const premium2Data = {
    className: "premium-2",
    analitikaPotrazivanjaIDugovanja1Props: analitikaPotrazivanjaIDugovanja5Data,
    analitikaPotrazivanjaIDugovanja2Props: analitikaPotrazivanjaIDugovanja6Data,
};

export const supportInfo2Data = {
    excepteurSintOccae: "/otplanding/excepteur-sint-occae-3@2x.png",
    className: "support-info-1",
};

export const x2MobileData = {
    footerINewsletter: "/otplanding/footer-i-newsletter-1.png",
    strateskiPartneri: "strateški partneri",
    activateLogo_Mono_Darkbg1: "/otplanding/activate-logo-mono-darkbg-1@2x.png",
    vector2: "/otplanding/vector-1@2x.png",
    x13: "/otplanding/13@2x.png",
    headerNavBar: "/otplanding/header-nav-bar@2x.png",
    soloLogoProtokolBeli8: "/otplanding/solo-logo-protokol-beli-8-1@2x.png",
    spanText1: "integriši",
    spanText2: ".",
    spanText3: "automatizuj",
    spanText4: ".",
    upravljaj: "upravljaj.",
    credoSentence: "/otplanding/credo-sentence@2x.png",
    x12: "/otplanding/12@2x.png",
    x14: "/otplanding/12@2x.png",
    frame52Props: frame522Data,
    moto2Props: moto22Data,
    x4Props: x42Data,
    x6Props: x62Data,
    x1Props: x13Data,
    x2Props: x22Data,
    x3Props: x32Data,
    protokolEkosistem1Props: protokolEkosistem3Data,
    protokolEkosistem2Props: protokolEkosistem4Data,
    svaPoslovnaResenjaNaJednomMestuProps: svaPoslovnaResenjaNaJednomMestu2Data,
    starterProps: starter2Data,
    premiumProps: premium2Data,
    supportInfoProps: supportInfo2Data,
};

